import React from "react";
import useScrollReveal from "../hooks/useScrollReveal";

const TimelineItem = ({ item, type, index }) => {
  const [ref, isVisible] = useScrollReveal({ delay: index * 150 });
  const bullets = item.description
    .split(/\.\s+(?=[A-Z])/)
    .map((s) => s.trim().replace(/\.$/, ""))
    .filter((s) => s.length > 0);

  return (
    <div
      ref={ref}
      className={`timeline-item ${isVisible ? "reveal-visible" : "reveal"}`}
    >
      <div className="timeline-dot" />
      <div className="timeline-content">
        <div className="timeline-date">{item.years || item.graduated}</div>
        <h3>{type === "work" ? item.company : item.school}</h3>
        <p className="info">
          {type === "work" ? item.title : item.degree}
          {item.location && (
            <>
              <span>&bull;</span> <em>{item.location}</em>
            </>
          )}
        </p>
        {type === "work" ? (
          <ul className="timeline-bullets">
            {bullets.map((b, i) => (
              <li key={i}>{b}</li>
            ))}
          </ul>
        ) : (
          <p>{item.description}</p>
        )}
      </div>
    </div>
  );
};

const Experience = ({ data }) => {
  const [workRef, workVisible] = useScrollReveal();
  const [eduRef, eduVisible] = useScrollReveal();

  if (!data) return null;

  return (
    <section id="experience" className="experience-section">
      <div className="floating-orb" />
      <div className="floating-orb" />
      <div className="energy-line" />
      <div className="energy-line" />
      <div className="energy-line" />
      <div className="row">
        <div className="twelve columns">
          <h1
            ref={workRef}
            className={`section-header ${workVisible ? "reveal-visible" : "reveal"}`}
          >
            <span>Experience</span>
          </h1>
          <div className="timeline">
            {data.work.map((job, i) => (
              <TimelineItem key={job.company} item={job} type="work" index={i} />
            ))}
          </div>

          <h1
            ref={eduRef}
            className={`section-header ${eduVisible ? "reveal-visible" : "reveal"}`}
          >
            <span>Education</span>
          </h1>
          <div className="timeline">
            {data.education.map((edu, i) => (
              <TimelineItem key={edu.school} item={edu} type="edu" index={i} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
